var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumTem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 167,
    viewBox: "0 0 73 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.483,
    y: 0.349976,
    width: 24.1333,
    height: 118.667,
    rx: 12.0667,
    fill: "#D9D9D9",
    stroke: "#FFE500",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.733,
    y: 47.8671,
    width: 23.6333,
    height: 70.9,
    rx: 11.8167,
    fill: "#FFE500"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.849976,
    y: 94.8835,
    width: 71.4,
    height: 71.4,
    rx: 35.7,
    fill: "#FFE500",
    stroke: "#FFE500",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumTem);
export default __webpack_public_path__ + "static/media/medium_tem.c92d4a0db58e823a5e2829ecda21e847.svg";
export { ForwardRef as ReactComponent };